import { useEffect, useState } from 'react'

/**
 * Trails `value` by `delayMs`, so a per-keystroke state change becomes one
 * settled value. Used for server-side search: the task list refetches on the
 * debounced value while the input itself stays immediate, so typing never feels
 * laggy and a five-letter query costs one request instead of five.
 */
export function useDebounced<T>(value: T, delayMs = 250): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const t = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(t)
  }, [value, delayMs])

  return settled
}
